import React, { useEffect } from 'react';
import { isDesktop } from 'react-device-detect';

import { OfficeHoursProvider } from './provider';
import OfficeHoursModalView from './OfficeHoursModalView';
import Tabs from './Tabs';

import { OfficeHoursModalProps } from './interfaces';
import { useLandscapeDetection } from '../../../../../../hooks/orientation';

const OfficeHoursModal = ({ open, handleClose }: OfficeHoursModalProps) => {
  const isLandscape = useLandscapeDetection();

  useEffect(() => {
    if (isDesktop || !open) {
      return;
    }

    if (!isLandscape) {
      handleClose();
    }
  }, [isLandscape, open, handleClose]);

  return (
    <OfficeHoursProvider>
      <OfficeHoursModalView open={open} handleClose={handleClose}>
        <Tabs />
      </OfficeHoursModalView>
    </OfficeHoursProvider>
  );
};

export default OfficeHoursModal;
